export default __webpack_public_path__ + "static/media/modalCloseIcon.6989224e.svg";